import { RiskScoreWindow } from '@amzn/gbsa-helios-typescript-client';

import type { Messages } from 'src/v2/shared/i18n/useMessages';
import type { RiskEngineMessageKey } from '../translations';
import { RISK_ENGINE_DEFAULT_WINDOW } from './riskScoreRequest';

const RISK_SCORE_WINDOW_BY_VALUE = new Map<string, RiskScoreWindow>(
  Object.values(RiskScoreWindow).map((window) => [window, window]),
);

/**
 * Decodes a raw value — a URL param or a filter selection — to a {@link RiskScoreWindow}, falling
 * back to the default window when the value is absent or unrecognised. Shared by the list page's
 * filter bar and the drill-down's window toggle so both treat an unknown value the same way.
 */
export function decodeRiskScoreWindow(value: string | null | undefined): RiskScoreWindow {
  return RISK_SCORE_WINDOW_BY_VALUE.get(value ?? '') ?? RISK_ENGINE_DEFAULT_WINDOW;
}

export interface TimeWindowOption {
  readonly label: string;
  readonly value: RiskScoreWindow;
}

/** The 7/14/30/90-day window options with localized labels, in order. */
export function buildTimeWindowOptions(
  t: Messages<RiskEngineMessageKey>['t'],
): TimeWindowOption[] {
  return [
    { label: t('timeWindowSevenDays'), value: RiskScoreWindow.SEVEN_DAY },
    { label: t('timeWindowFourteenDays'), value: RiskScoreWindow.FOURTEEN_DAY },
    { label: t('timeWindowThirtyDays'), value: RiskScoreWindow.THIRTY_DAY },
    { label: t('timeWindowNinetyDays'), value: RiskScoreWindow.NINETY_DAY },
  ];
}
